import { render } from "./LargerCard.vue?vue&type=template&id=4b8c67eb"
import script from "./LargerCard.vue?vue&type=script&lang=js"
export * from "./LargerCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__